// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"607":"affdcccf","888":"55a7b436"}[chunkId] + ".chunk.js";
};